import {Button, Card, Col, Divider, Form, message, Modal, Row, Spin, Statistic} from "antd";
import '../../customerTemplates/style.scss'
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faRepeat} from "@fortawesome/free-solid-svg-icons/faRepeat";
import documentService from "../../../service/documentService";
import {
    DOC_CODE_INVEST_TRANSACTION_DOCUMENT,
    DOC_CODE_SWITCH_TRANSACTION_DOCUMENT,
    DOC_CODE_TRANSFER_TRANSACTION_DOCUMENT,
    DOC_CODE_WITHDRAW_TRANSACTION_DOCUMENT,
    PREVIEW_DOC_TYPES,
    TRANSACTION_SUMMARY_PAGE_TYPES,
    YYYY_MM_DD
} from "../../../util/Constants";
import {MSG_FAILED_TO_FETCH_DOCUMENTS_ERROR} from "../../../util/Messages";
import ErrorHandler from "../../../util/ErrorHandler";
import {useEffect, useState} from "react";
import {UploadedDocumentDetailDto} from "../../../dto/UploadedDocumentDetailDto";
import {TransactionSummaryDto} from "../../../dto/TransactionSummaryDto";
import CommonFunction from "../../../util/CommonFunction";
import {DownloadOutlined, EyeOutlined} from "@ant-design/icons";
import PreviewModalComp from "../../../components/common/preview/PreviewModalComp";
import {faCreditCard, faMoneyBillTransfer, faSackDollar} from "@fortawesome/free-solid-svg-icons";
import dayjs from "dayjs";


interface TransactionSummaryProps {
    summaryData: TransactionSummaryDto
    onClose: () => void
    summaryPageType: TRANSACTION_SUMMARY_PAGE_TYPES
}

const TransactionSummaryPage = (props: TransactionSummaryProps) => {
    const [uploadedDocument, setUploadedDocument] = useState<UploadedDocumentDetailDto>();

    const [documentName, setDocumentName] = useState<string>("")
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isLoading, setLoading] = useState(false);
    const [docURL, setDocURL] = useState('');
    const [docType, setDocType] = useState<PREVIEW_DOC_TYPES>(PREVIEW_DOC_TYPES.IMAGE);

    useEffect(() => {
        getUploadedDocument()

    }, []);

    const setDocuments = (documentList: [] | undefined) => {
        if (undefined != documentList) {
            documentList.map((document: any) => {
                let uploadDocumentDetailDto: UploadedDocumentDetailDto = document.uploadDocumentDetailDto;

                if (null != uploadDocumentDetailDto) {
                    setUploadedDocument(uploadDocumentDetailDto)
                }
            })
        }
    };

    const checkDocumentCode = () => {
        switch (props.summaryPageType) {
            case TRANSACTION_SUMMARY_PAGE_TYPES.INVEST:
                return DOC_CODE_INVEST_TRANSACTION_DOCUMENT;
            case TRANSACTION_SUMMARY_PAGE_TYPES.SWITCH:
                return DOC_CODE_SWITCH_TRANSACTION_DOCUMENT;
            case TRANSACTION_SUMMARY_PAGE_TYPES.TRANSFER:
                return DOC_CODE_TRANSFER_TRANSACTION_DOCUMENT;
            case TRANSACTION_SUMMARY_PAGE_TYPES.WITHDRAW:
                return DOC_CODE_WITHDRAW_TRANSACTION_DOCUMENT;
        }
    }
    const getUploadedDocument = () => {

        if (props.summaryData.documentId) {
            documentService.getUploadDocumentListByTypeAndUploadedDocId(props.summaryData.jobNumber, props.summaryData.documentId, [checkDocumentCode()]).then(res => {
                if (res.data !== null) {
                    setDocuments(res.data.results)
                } else {
                    message.error(MSG_FAILED_TO_FETCH_DOCUMENTS_ERROR).then();
                }
            }, (reason) => {
                ErrorHandler.handleError(reason);
            })
        }
    }
    const onClose = () => {
        props.onClose()
    }

    const openModal = (documentId: string, docTypeName: string) => {
        setLoading(true)
        documentService.viewOriginalDocument(documentId).then(res => {
            if (res.data !== null) {
                setIsModalOpen(true)
                setDocURL(res.data.results)
                setDocumentName(docTypeName)
                setDocType(CommonFunction.checkDocumentContentType(res.data.results))
                setLoading(false)
            } else {
                message.error(MSG_FAILED_TO_FETCH_DOCUMENTS_ERROR).then();
                setLoading(false)
            }
        }, (reason) => {
            setLoading(false)
            ErrorHandler.handleError(reason);
        })
        return true;
    };

    const handlePreviewCancel = () => {
        setIsModalOpen(false);
    };

    const processMonthCount = (count: number) => {
        if (count == 0) return "N/A";
        if (count > 1) {
            return `${count} months`
        } else {
            return `${count} month`
        }
    }
    return (
        <Col lg={14} md={14} sm={24}
             className='right-side-main-container-inside-dashboard align-div-center dashboard-right-side-contaner-scroll layout-bottom-space'>

            <div className='account_type_container second-applicant-details' style={{paddingTop: 16}}>
                {TRANSACTION_SUMMARY_PAGE_TYPES.SWITCH === props.summaryPageType ?
                    <div>
                        <Row gutter={[32, 0]}>
                            <Col xs={24} sm={24} md={24} lg={24} xl={24} className='page-header-main-title-col'>
                                <h2 className='page-header-main-title'>
                                    <div className='header_icon header-icon-center'>
                                        <FontAwesomeIcon icon={faRepeat}/>
                                    </div>
                                    Switching Request Summary
                                </h2>
                            </Col>
                        </Row>
                        <Row>
                            <Col span={24}>
                                <Spin spinning={isLoading}>
                                    <Card className={'template_card'}>
                                        <Row gutter={[32, 16]} className={'template_request_statistic'}>
                                            <Col span={24}>
                                                <Divider orientationMargin="0" orientation="left"
                                                         className={'template-summary-divider'}>Entered Request
                                                    Details</Divider>
                                            </Col>
                                            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                                <h3 className={'tr-summary-from-to-h3'}>Switch From</h3>
                                            </Col>
                                            <Col xs={24} sm={24} md={24} lg={24} xl={12} xxl={12}>
                                                <Statistic title="Portfolio ID" formatter={(value: string) => value}
                                                           value={CommonFunction.validateText(props.summaryData.portfolio)}/>
                                            </Col>
                                            <Col xs={24} sm={24} md={24} lg={24} xl={12} xxl={12}>
                                                <Statistic title="Fund" formatter={(value: string) => value}
                                                           value={CommonFunction.validateText(props.summaryData.fund)}/>
                                            </Col>
                                            <Col xs={24} sm={24} md={24} lg={24} xl={12} xxl={12}>
                                                <Statistic title="Amount"
                                                           value={`LKR ${props.summaryData.switchAmount}`}/>
                                            </Col>
                                            <Col span={24}>
                                                <Divider style={{margin: 0}}></Divider>
                                            </Col>
                                            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                                <h3 className={'tr-summary-from-to-h3'}>Switch To</h3>
                                            </Col>

                                            <Col xs={24} sm={24} md={24} lg={24} xl={12} xxl={12}>
                                                <Statistic title="Fund" formatter={(value: string) => value}
                                                           value={CommonFunction.validateText(props.summaryData.switchFund)}/>
                                            </Col>

                                            {uploadedDocument ? <Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24}>
                                                <Statistic className={'hide-value'} title="Uploaded Document"
                                                           value={''}/>
                                                <div className='utility_bill img-nic'>
                                                    <div className='utulity_bill_icon_div'>
                                                        <div className="img_div">
                                                            <img src={uploadedDocument?.thumbB64} alt=""/>
                                                        </div>
                                                        <div className='name_div'>
                                                            <h5>{uploadedDocument?.documentTypeName}</h5>
                                                        </div>
                                                    </div>
                                                    <Button className='doc-view-btn'
                                                            onClick={() => openModal(String(uploadedDocument?.uploadDocumentDetailId), uploadedDocument?.originalDocumentName)}><EyeOutlined/></Button>
                                                </div>
                                            </Col> : <></>}

                                            <Col span={24} style={{marginTop: 8}}>
                                                <Divider orientationMargin="0" orientation="left"
                                                         className={'template-summary-divider'}>System Generated
                                                    Details</Divider>
                                            </Col>
                                            <Col xs={24} sm={24} md={24} lg={12} xl={12} xxl={12}>
                                                <Statistic title="Autogenerated Reference Number"
                                                           formatter={(value: string) => value}
                                                           value={CommonFunction.validateText(props.summaryData.refNumber)}/>
                                            </Col>
                                            <Col xs={24} sm={24} md={24} lg={12} xl={12} xxl={12}>
                                                <Statistic title="Processing Date" formatter={(value: string) => value}
                                                           value={CommonFunction.validateText(props.summaryData.processingDate)}/>
                                            </Col>
                                        </Row>
                                    </Card>
                                </Spin>
                            </Col>
                        </Row>
                    </div>
                    :
                    TRANSACTION_SUMMARY_PAGE_TYPES.TRANSFER === props.summaryPageType ?
                        <div>
                            <Row gutter={[32, 0]}>
                                <Col xs={24} sm={24} md={24} lg={24} xl={24} className='page-header-main-title-col'>
                                    <h2 className='page-header-main-title'>
                                        <div className='header_icon header-icon-center'>
                                            <FontAwesomeIcon icon={faMoneyBillTransfer}/>
                                        </div>
                                        Transfer Request Summary
                                    </h2>
                                </Col>
                            </Row>
                            <Row>
                                <Col span={24}>
                                    <Spin spinning={isLoading}>
                                        <Card className={'template_card'}>
                                            <Row gutter={[32, 16]} className={'template_request_statistic'}>
                                                <Col span={24}>
                                                    <Divider orientationMargin="0" orientation="left"
                                                             className={'template-summary-divider'}>Entered Request
                                                        Details</Divider>
                                                </Col>
                                                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                                    <h3 className={'tr-summary-from-to-h3'}>Transfer From</h3>
                                                </Col>

                                                <Col xs={24} sm={24} md={24} lg={24} xl={12} xxl={12}>
                                                    <Statistic title="Portfolio ID" formatter={(value: string) => value}
                                                               value={CommonFunction.validateText(props.summaryData.portfolio)}/>
                                                </Col>
                                                <Col xs={24} sm={24} md={24} lg={24} xl={12} xxl={12}>
                                                    <Statistic title="Fund" formatter={(value: string) => value}
                                                               value={CommonFunction.validateText(props.summaryData.fund)}/>
                                                </Col>
                                                <Col xs={24} sm={24} md={24} lg={24} xl={12} xxl={12}>
                                                    <Statistic title="Amount"
                                                               value={`LKR ${props.summaryData.transferAmount}`}/>
                                                </Col>
                                                <Col span={24}>
                                                    <Divider style={{margin: 0}}></Divider>
                                                </Col>
                                                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                                    <h3 className={'tr-summary-from-to-h3'}>Transfer To</h3>
                                                </Col>

                                                <Col xs={24} sm={24} md={24} lg={24} xl={12} xxl={12}>
                                                    <Statistic title="Account Type" formatter={(value: string) => value}
                                                               value={CommonFunction.validateText(props.summaryData.transferAccountType)}/>
                                                </Col>
                                                <Col xs={24} sm={24} md={24} lg={24} xl={12} xxl={12}>
                                                    <Statistic title="Portfolio ID" formatter={(value: string) => value}
                                                               value={CommonFunction.validateText(props.summaryData.transferPortfolio)}/>
                                                </Col>
                                                {null != props.summaryData.transferPortfolioCustomerName ?
                                                    <Col xs={24} sm={24} md={24} lg={24} xl={12} xxl={12}>
                                                        <Statistic title="Name" formatter={(value: string) => value}
                                                                   value={CommonFunction.validateText(props.summaryData.transferPortfolioCustomerName)}/>
                                                    </Col>
                                                    : <></>}
                                                {uploadedDocument ?
                                                    <Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24}>
                                                        <Statistic className={'hide-value'} title="Uploaded Document"
                                                                   value={''}/>
                                                        <div className='utility_bill img-nic'>
                                                            <div className='utulity_bill_icon_div'>
                                                                <div className="img_div">
                                                                    <img src={uploadedDocument?.thumbB64} alt=""/>
                                                                </div>
                                                                <div className='name_div'>
                                                                    <h5>{uploadedDocument?.documentTypeName}</h5>
                                                                </div>
                                                            </div>
                                                            <Button className='doc-view-btn'
                                                                    onClick={() => openModal(String(uploadedDocument?.uploadDocumentDetailId), uploadedDocument?.originalDocumentName)}><EyeOutlined/></Button>
                                                        </div>
                                                    </Col> : <></>}

                                                <Col span={24} style={{marginTop: 8}}>
                                                    <Divider orientationMargin="0" orientation="left"
                                                             className={'template-summary-divider'}>System Generated
                                                        Details</Divider>
                                                </Col>
                                                <Col xs={24} sm={24} md={24} lg={12} xl={12} xxl={12}>
                                                    <Statistic title="Autogenerated Reference Number"
                                                               formatter={(value: string) => value}
                                                               value={CommonFunction.validateText(props.summaryData.refNumber)}/>
                                                </Col>
                                                <Col xs={24} sm={24} md={24} lg={12} xl={12} xxl={12}>
                                                    <Statistic title="Processing Date"
                                                               formatter={(value: string) => value}
                                                               value={CommonFunction.validateText(props.summaryData.processingDate)}/>
                                                </Col>
                                            </Row>
                                        </Card>
                                    </Spin>
                                </Col>
                            </Row>
                        </div>
                        :
                        TRANSACTION_SUMMARY_PAGE_TYPES.WITHDRAW === props.summaryPageType ?
                            <div>
                                <Row gutter={[32, 0]}>
                                    <Col xs={24} sm={24} md={24} lg={24} xl={24} className='page-header-main-title-col'>
                                        <h2 className='page-header-main-title'>
                                            <div className='header_icon header-icon-center'>
                                                <FontAwesomeIcon icon={faCreditCard}/>
                                            </div>
                                            Withdrawal Request Summary
                                        </h2>
                                    </Col>
                                </Row>

                                <Spin spinning={isLoading}>
                                    <Card className={'template_card'}>
                                        <Row gutter={[32, 16]} className={'template_request_statistic'}>
                                            <Col span={24}>
                                                <Divider orientationMargin="0" orientation="left"
                                                         className={'template-summary-divider'}>Entered Request
                                                    Details</Divider>
                                            </Col>
                                            <Col xs={24} sm={24} md={24} lg={24} xl={12} xxl={12}>
                                                <Statistic title="Withdraw Type"
                                                           value={CommonFunction.validateText(props.summaryData.withdrawalMethod)}/>
                                            </Col>

                                            <Col xs={24} sm={24} md={24} lg={24} xl={12} xxl={12}>
                                                <Statistic title="Portfolio ID" formatter={(value: string) => value}
                                                           value={CommonFunction.validateText(props.summaryData.portfolio)}/>
                                            </Col>
                                            <Col xs={24} sm={24} md={24} lg={24} xl={12} xxl={12}>
                                                <Statistic title="Fund" formatter={(value: string) => value}
                                                           value={CommonFunction.validateText(props.summaryData.fund)}/>
                                            </Col>

                                            <Col xs={24} sm={24} md={24} lg={24} xl={12} xxl={12}>
                                                <Statistic title="Amount"
                                                           value={`LKR ${props.summaryData.withdrawAmount}`}/>
                                            </Col>

                                            <Col xs={24} sm={24} md={24} lg={24} xl={12} xxl={12}>
                                                <Statistic title="Bank Account"
                                                           value={CommonFunction.validateText(props.summaryData.bankAccount)}/>
                                            </Col>
                                            {/*{"Other" == props.summaryData.bankAccount ?*/}
                                            {/*    <Col xs={24} sm={24} md={24} lg={24} xl={12} xxl={12}>*/}
                                            {/*        <Statistic title="Existing Template"*/}
                                            {/*                   value={CommonFunction.validateText(props.summaryData.existingTemplate)}/>*/}
                                            {/*    </Col> : <></>}*/}

                                            {"Online" != props.summaryData.withdrawalMethod ?
                                                <>
                                                    <Col xs={24} sm={24} md={24} lg={24} xl={12} xxl={12}>
                                                        <Statistic title="Withdrawal Frequency"
                                                                   value={CommonFunction.validateText(props.summaryData.withdrawalFrequency)}/>
                                                    </Col>


                                                    {"One Time" != props.summaryData.withdrawalFrequency ?
                                                        <Col xs={24} sm={24} md={24} lg={24} xl={12} xxl={12}>
                                                            <Statistic title="Month Count"
                                                                       value={processMonthCount(props.summaryData.withdrawalMonthCount as number)}/>
                                                        </Col> : <></>}

                                                    <Col xs={24} sm={24} md={24} lg={24} xl={12} xxl={12}>
                                                        <Statistic title="Withdrawal Date"
                                                                   value={dayjs(props.summaryData.scheduledDate).format(YYYY_MM_DD)}/>
                                                    </Col>
                                                </>
                                                : <></>}

                                            {props.summaryData.isCanShowNewBankDetails ?
                                                <>
                                                    <Col span={24} style={{marginTop: 8}}>
                                                        <Divider orientationMargin="0" orientation="left"
                                                                 className={'template-summary-divider'}>New Bank
                                                            Details</Divider>
                                                    </Col>
                                                    {/*<Col xs={24} sm={24} md={24} lg={12} xl={12} xxl={12}>*/}
                                                    {/*    <Statistic title="Template Name"*/}
                                                    {/*               value={CommonFunction.validateText(props.summaryData.templateName)}/>*/}
                                                    {/*</Col>*/}
                                                    <Col xs={24} sm={24} md={24} lg={12} xl={12} xxl={12}>
                                                        <Statistic title="Name of the Bank"
                                                                   value={CommonFunction.validateText(props.summaryData.bankName)}/>
                                                    </Col>
                                                    <Col xs={24} sm={24} md={24} lg={12} xl={12} xxl={12}>
                                                        <Statistic title="Branch"
                                                                   value={CommonFunction.validateText(props.summaryData.branch)}/>
                                                    </Col>
                                                    <Col xs={24} sm={24} md={24} lg={12} xl={12} xxl={12}>
                                                        <Statistic title="Account Number"
                                                                   formatter={(value: string) => value}
                                                                   value={CommonFunction.validateText(props.summaryData.accountNumber)}/>
                                                    </Col>
                                                    <Col xs={24} sm={24} md={24} lg={12} xl={12} xxl={12}>
                                                        <Statistic title="Account Holder`s Name"
                                                                   value={CommonFunction.validateText(props.summaryData.accountHolderName)}/>
                                                    </Col>
                                                </> : <></>}
                                            {uploadedDocument ?
                                                <Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24}>
                                                    <Statistic className={'hide-value'} title="Uploaded Document"
                                                               value={''}/>
                                                    <div className='utility_bill img-nic'>
                                                        <div className='utulity_bill_icon_div'>
                                                            <div className="img_div">
                                                                <img src={uploadedDocument?.thumbB64} alt=""/>
                                                            </div>
                                                            <div className='name_div'>
                                                                <h5>{uploadedDocument?.documentTypeName}</h5>
                                                            </div>
                                                        </div>
                                                        <Button className='doc-view-btn'
                                                                onClick={() => openModal(String(uploadedDocument?.uploadDocumentDetailId), uploadedDocument?.originalDocumentName)}><EyeOutlined/></Button>
                                                    </div>
                                                </Col> : <></>}

                                            <Col span={24} style={{marginTop: 8}}>
                                                <Divider orientationMargin="0" orientation="left"
                                                         className={'template-summary-divider'}>System Generated
                                                    Details</Divider>
                                            </Col>
                                            <Col xs={24} sm={24} md={24} lg={12} xl={12} xxl={12}>
                                                <Statistic title="Autogenerated Reference Number"
                                                           formatter={(value: string) => value}
                                                           value={CommonFunction.validateText(props.summaryData.refNumber)}/>
                                            </Col>
                                            {"Monthly" != props.summaryData.withdrawalFrequency ?
                                                <Col xs={24} sm={24} md={24} lg={12} xl={12} xxl={12}>
                                                    <Statistic title="Processing Date"
                                                               formatter={(value: string) => value}
                                                               value={CommonFunction.validateText(props.summaryData.processingDate)}/>
                                                </Col> : <></>}
                                        </Row>
                                    </Card>
                                </Spin>

                            </div>
                            :
                            TRANSACTION_SUMMARY_PAGE_TYPES.INVEST === props.summaryPageType ?
                                <div>
                                    <Row gutter={[32, 0]}>
                                        <Col xs={24} sm={24} md={24} lg={24} xl={24}
                                             className='page-header-main-title-col'>
                                            <h2 className='page-header-main-title'>
                                                <div className='header_icon header-icon-center'>
                                                    <FontAwesomeIcon icon={faSackDollar}/>
                                                </div>
                                                Investment Request Summary
                                            </h2>
                                        </Col>
                                    </Row>
                                    <Spin spinning={isLoading}>
                                        <Card className={'template_card'}>
                                            <Row gutter={[32, 16]} className={'template_request_statistic'}>
                                                <Col span={24}>
                                                    <Divider orientationMargin="0" orientation="left"
                                                             className={'template-summary-divider'}>Entered Request
                                                        Details</Divider>
                                                </Col>
                                                <Col xs={24} sm={24} md={24} lg={24} xl={12} xxl={12}>
                                                    <Statistic title="Portfolio" formatter={(value: string) => value}
                                                               value={CommonFunction.validateText(props.summaryData.portfolio)}/>
                                                </Col>
                                                <Col xs={24} sm={24} md={24} lg={24} xl={12} xxl={12}>
                                                    <Statistic title="Fund" formatter={(value: string) => value}
                                                               value={CommonFunction.validateText(props.summaryData.fund)}/>
                                                </Col>

                                                <Col xs={24} sm={24} md={24} lg={24} xl={12} xxl={12}>
                                                    <Statistic title="Amount"
                                                               value={`LKR ${props.summaryData.investAmount}`}/>
                                                </Col>

                                                <Col xs={24} sm={24} md={24} lg={24} xl={12} xxl={12}>
                                                    <Statistic title="Collection Account"
                                                               formatter={(value: string) => value}
                                                               value={CommonFunction.validateText(props.summaryData.collectionAccount)}/>
                                                </Col>

                                                <Col xs={24} sm={24} md={24} lg={24} xl={12} xxl={12}>
                                                    <Statistic title="Transaction Reference Number"
                                                               formatter={(value: string) => value}
                                                               value={CommonFunction.validateText(props.summaryData.transactionRefNo)}/>
                                                </Col>

                                                {uploadedDocument ?
                                                    <Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24}>
                                                        <Statistic className={'hide-value'} title="Uploaded Document"
                                                                   value={''}/>
                                                        <div className='utility_bill img-nic'>
                                                            <div className='utulity_bill_icon_div'>
                                                                <div className="img_div">
                                                                    <img src={uploadedDocument?.thumbB64} alt=""/>
                                                                </div>
                                                                <div className='name_div'>
                                                                    <h5>{uploadedDocument?.documentTypeName}</h5>
                                                                </div>
                                                            </div>
                                                            <Button className='doc-view-btn'
                                                                    onClick={() => openModal(String(uploadedDocument?.uploadDocumentDetailId), uploadedDocument?.originalDocumentName)}><EyeOutlined/></Button>
                                                        </div>
                                                    </Col> : <></>}

                                                <Col span={24} style={{marginTop: 8}}>
                                                    <Divider orientationMargin="0" orientation="left"
                                                             className={'template-summary-divider'}>System Generated
                                                        Details</Divider>
                                                </Col>
                                                <Col xs={24} sm={24} md={24} lg={12} xl={12} xxl={12}>
                                                    <Statistic title="Autogenerated Reference Number"
                                                               formatter={(value: string) => value}
                                                               value={CommonFunction.validateText(props.summaryData.refNumber)}/>
                                                </Col>
                                                <Col xs={24} sm={24} md={24} lg={12} xl={12} xxl={12}>
                                                    <Statistic title="Processing Date"
                                                               formatter={(value: string) => value}
                                                               value={CommonFunction.validateText(props.summaryData.processingDate)}/>
                                                </Col>
                                            </Row>
                                        </Card>
                                    </Spin>
                                </div>
                                :
                                <></>}
                <div>
                    <Row gutter={[32, 0]}>

                        <Col sm={24} lg={{span: 8, offset: 16}} className='continue-btn-col text-right'>
                            <Form.Item className='form-item-btn'>

                                <Button className={'summary-footer-btn-close'} htmlType="button" onClick={onClose}>
                                    Close
                                </Button>
                            </Form.Item>
                        </Col>

                    </Row>
                </div>
            </div>
            <Modal
                className={docType == PREVIEW_DOC_TYPES.PDF ? "modal-custom-bg" : "image-view-modal"}
                open={isModalOpen}
                centered
                title={documentName}
                onCancel={handlePreviewCancel}
                destroyOnClose={true}
                width={docType == PREVIEW_DOC_TYPES.PDF ? 800 : 600}
                footer={[
                    <Button type="primary" icon={<DownloadOutlined/>} style={{background: '#FF7400', height: 40}}
                            htmlType="submit" onClick={() => CommonFunction.download(docURL, documentName)}>
                        Download
                    </Button>]}>
                <PreviewModalComp docURL={docURL}/>
            </Modal>
        </Col>
    )

}
export default TransactionSummaryPage;

